module.exports = __webpack_public_path__ + "assets/img/7234-flags.png";